<div>
    <div class="head-section">
        <h6 class="header-text text-white">Reconcile MDA Bills</h6>
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="close()">
            <g clip-path="url(#clip0_3558_32756)">
                <path d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345" stroke="#F00000" stroke-width="2.16781" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3558_32756">
                    <rect width="17.3425" height="17.3425" fill="white" transform="translate(0.806641 0.748047)"/>
                </clipPath>
            </defs>
        </svg>
    </div>
    <div class="body-section">
    
        <div class="mt-2 mb-3" style="position: relative;border: 1px solid #ccc;border-radius: 10px; background: #fff">
            <b style="position: absolute;background: #fff;padding: 0 10px;top: -12px;left: 20px">Payment Details</b>

            <div class="row p-5">
                <div class="col-md-6">
                    <div class="input-bundled">
                        <label>Taxpayer Name</label>
                        <select>
                            <option>{{paymentDetails?.taxpayer_name | titlecase}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Description</label>
                        <select>
                            <option>{{paymentDetails?.mdaRecordName | titlecase}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Payment Amount</label>
                        <select>
                            <option>{{paymentDetails?.amount | nairaCurrency}}</option>
                        </select>
                    </div>
                   
                </div>
                <div class="col-md-6">
                   
                    <div class="input-bundled">
                        <label>ASIN</label> 
                        <select>
                            <option>{{paymentDetails?.asin | uppercase}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Revenue Code</label>
                        <select>
                            <option>{{paymentDetails?.revenueCode | uppercase}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Payment Date</label>
                        <select>
                            <option>{{paymentDetails?.date | dateonly}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>


       

    

        <div class="modal-footer">
            <div class="action-buttons">
                <button (click)="confirmSave()" type="button" class="btn submit-button" >
                    <b *ngIf="!isSaving">Reconcile</b>
                    <b *ngIf="isSaving"  class="spinner-border text-dark"></b>
                </button>
                
            </div>


        </div>
    </div>
</div>
